import { useParams } from 'react-router-dom';
import React from 'react';
import TicketForm from './TicketForm.js';

export default function ValidationForms() {
  let { id } = useParams();
  return <TicketForm id={id} />;
}
